import {Detail, FlexRow, tokensForThemeProvider} from '@forecast-it/design-system';
import React from 'react';
import {NovaLabelChip} from './NovaLabelChip';

export interface RoutingDisclosureProps {
	agentName: string;
	reason?: string;
}

// One step deeper than the reply tag opposite it, which carries blue/50 on the untinted card. The
// two are the same label on either side of the exchange, and the step between them is what keeps
// the agent's name legible on the tinted answer card while the reply's stays legible on the plain
// one.
const AGENT_CHIP_SURFACE = tokensForThemeProvider.sky.ref.color.blue['100'];

export const RoutingDisclosure = (props: RoutingDisclosureProps): JSX.Element => (
	<FlexRow>
		<NovaLabelChip surface={AGENT_CHIP_SURFACE} data-cy="nova-agent-chip">
			{props.agentName}
		</NovaLabelChip>
		{props.reason && (
			<Detail data-cy="nova-routing-reason" color="medium">
				{props.reason}
			</Detail>
		)}
	</FlexRow>
);
